import React, { useEffect, useRef, useState } from "react";
import { Navigate, Outlet, useMatch, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import genericUtility from "../services/utility/GenericUtility";
import { AppDispatch, RootState } from "../dataManagement/uiDb/UiDb";
import { fetchProfile } from "../services/thunks/ProfileThunk";

const LoadUserData: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const token = genericUtility.getCookie("token");
  const profile = useSelector((state: RootState) => state.profile);
  const [noTokenPresent, setNoTokenPresent] = useState<boolean>(false);
  const didRunRef = useRef(false);

  useEffect(() => {
    const validateUserAndFetchProfile = async () => {
      // Check token validity first
      if (token == null) {
        setNoTokenPresent(true);
        return;
      }
      if (profile && profile.data) {
        return;
      }
      try {
        // Fetch and validate profile
        const resultAction = await dispatch(fetchProfile());
        if (fetchProfile.rejected.match(resultAction)) {
          const payload = resultAction.payload as any;
          const isProfileFetchError = payload?.errorInformation?.some(
            (err: any) => err.errorCode === "102"
          );

          if (isProfileFetchError) {
            genericUtility.logout(navigate);
            return;
          }
        }
      } catch (error) {
        console.error("Profile validation failed:", error);
      }
    };
    if (!didRunRef.current) {
      didRunRef.current = true;
      validateUserAndFetchProfile();
    }
  }, []);

  // Public business pages render immediately: they fetch their own data and
  // read profile-derived flags (isAdmin, curator role) reactively, so there is
  // no reason to hold the business fetch behind fetchProfile(). The profile
  // fetch above still runs in parallel.
  const isPublicBusinessPage = useMatch("/business/:id") != null;

  // Show loading state while validation is in progress
  return (
    <div>{(isPublicBusinessPage || noTokenPresent || (profile && profile.data)) && <Outlet />}</div>
  );
};

export default LoadUserData;
